module.exports = __webpack_public_path__ + "static/img/Frame-121.a030639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame-121.png
// module id = ySSE
// module chunks = 1